export const fetchAddresses = async (apiEndpoint, idRelated) => {
    let addresses = [];
    let pagination = {
        limit: 100,
        offset: '',
    };
    do {
        const response = await ApiClient.get(`${apiEndpoint}/${idRelated}/addresses`, pagination);
        addresses = addresses.concat(response.data.data);
        pagination = response.data.pagination;
    } while (pagination.total > addresses.length);
    return addresses;
};

export const deleteAddress = async (apiEndpoint, idRelated, addressId) => {
    return ApiClient.del(`${apiEndpoint}/${idRelated}/addresses/${addressId}`);
};

export const updateAddress = async (apiEndpoint, idRelated, addressId, address) => {
    return ApiClient.put(`${apiEndpoint}/${idRelated}/addresses/${addressId}`, {}, address);
};

export const fetchAccountAddresses = async () => {
    let addresses = [];
    let pagination = {
        limit: 100,
        offset: '',
    };
    do {
        const response = await ApiClient.get('/addresses', pagination);
        addresses = addresses.concat(response.data.data);
        pagination = response.data.pagination;
    } while (pagination.total > addresses.length);
    return addresses;
};

export const deleteAccountAddress = (addressId) => {
    return ApiClient.del(`/addresses/${addressId}`);
};

export const updateAccountAddress = (addressId, address) => {
    return ApiClient.put(`/addresses/${addressId}`, {}, address);
};
